export default "__VITE_ASSET__DoLmThzh__"